import React                 from 'react';
import { Observe }                from 'rewire-core';
import {
  WithStyle,
  withStyles,
  FormView,
  IActionMenuItem,
}                                 from 'rewire-ui';
import { Theme }                  from '@material-ui/core/styles';
import { makeStyles }             from '../utility/styles';
import DeleteIcon                 from '@material-ui/icons/DeleteOutlined';
import LockIcon                   from '@material-ui/icons/Lock';
import DraggableResizableDialog   from '../ui/DraggableResizableDialog';
import OptionsActionMenu          from '../ui/OptionsActionMenu';
import templateDialogModel        from './TemplateDialogModel';
import TimecardTemplateGridModel  from './TimecardTemplateGridModel';
import TimecardTemplateGrid, {
  TimecardTemplateGridHeader,
}                                 from './TimecardTemplateGrid';
import TimecardGridModel from './TimecardGridModel';

const useTemplateGridStyles = makeStyles((_theme: Theme) => ({
  gridRoot: {
    minHeight: '176px',
  },
  gridHeaderRoot: {
    margin: '0px 16px 5px 16px',
  },
  gridContainer: {
    height: '225px',
    margin: '0px 16px 16px 16px',
  },
  grid: {
    maxHeight: '225px',
  },
  gridLevelErrors: {
    margin: '0px 16px',
    height: '36px',
  },
}));

export const TemplateGridView = ({ model, classes }: { model: TimecardTemplateGridModel, classes?: any }) => {
  const gridClasses = useTemplateGridStyles({classes});

  return <Observe render={() => (
    < >
      <TimecardTemplateGridHeader
        model={model as TimecardGridModel}
        classes={{root: gridClasses.gridHeaderRoot}}
      />
      <TimecardTemplateGrid
        model={model as TimecardGridModel}
        classes={{root: gridClasses.gridRoot, gridContainer: gridClasses.gridContainer, grid: gridClasses.grid, gridLevelErrors: gridClasses.gridLevelErrors}}
      />
    </>
  )} />;
};

const styles = (_theme: Theme) => ({
  dialogTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dialogTitleLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  lockIcon: {
    marginLeft: '10px',
  },
  dialogHeading: {
    alignItems: 'stretch',
  },
});

interface ITemplateDialogProps {
}

type TemplateDialogProps = WithStyle<ReturnType<typeof styles>, ITemplateDialogProps>;

class TemplateDialog extends React.PureComponent<TemplateDialogProps> {
  optionsActionMenuItems: IActionMenuItem[];

  constructor(props: TemplateDialogProps) {
    super(props);

    this.optionsActionMenuItems = [
      // {name: 'duplicateTemplate', title: 'Duplicate Shift Type', icon: FileCopyIcon, onClick: this.handleDuplicateTemplateClick, closeOnClick: true, disabled: () => !templateDialogModel.canAdd || templateDialogModel.hasChanges()},
      {name: 'deleteTemplate',    title: 'Delete Shift Type',    icon: DeleteIcon,   onClick: this.handleDeleteTemplateClick,    closeOnClick: true, disabled: () => templateDialogModel.locked || !templateDialogModel.canDelete || templateDialogModel.isNew},
    ];
  }

  componentWillUnmount() {
    templateDialogModel.reset();
  }

  // handleDuplicateTemplateClick = () => {
  //   templateDialogModel.showDuplicateTemplateDialog();
  // }

  handleDeleteTemplateClick = () => {
    templateDialogModel.deleteTemplate();
  };

  renderTitle = (): JSX.Element => {
    const {classes} = this.props;

    return (
      <div className={classes.dialogTitleContainer}>
        <div className={classes.dialogTitleLabel}>{templateDialogModel.title}{templateDialogModel.locked && <LockIcon className={classes.lockIcon} />}</div>
        {!templateDialogModel.isNew && <div onMouseDown={(e) => { e.stopPropagation(); }}><OptionsActionMenu title='Shift Type Options' tooltip='Shift Type Options' items={this.optionsActionMenuItems} /></div>}
      </div>
    );
  };

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      < >
      <FormView form={templateDialogModel.form} onSubmit={templateDialogModel.actionFn('save')}>
        <div className='content'>
          {templateDialogModel.form.fields.map((field, i) => (
            <field.Editor className='span2' key={i} />
          ))}
        </div>
      </FormView>
      <TemplateGridView model={templateDialogModel.timecardTemplateGridModel} />
      </>
    )} />;
  });

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='md' DialogProps={{dialog: templateDialogModel, disableEnforceFocus: true, title: this.renderTitle, actions: ['cancel', 'save']}} DraggableResizableBoxProps={{minWidth: '370px', minHeight: '595px'}} classes={{heading: classes.dialogHeading}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<ITemplateDialogProps,unknown>(styles, TemplateDialog);
